// extracted by mini-css-extract-plugin
export default {"placeholder":"oZ5tk","button":"wfZF7","russianPost":"T9Q97","buttonContent":"IQrx0","icon":"D0cEK","buttonText":"kxojZ","contactRussianPostPopup":"EbnaC"};